import React, {useState} from "react";
// import mainlogo from '../../assets/images/admin/mainlogo.png';
// import mainlogo1 from '../../assets/images/srlogo.jpeg';
// import mainlogo2 from '../../assets/images/srlogo1.jpeg';
import mainlogo from '../../assets/images/logo.png';
import { Link } from "react-router-dom";
import dashboardicon from '../../assets/images/admin/sidebar/Dashboard.svg';
import shoppingcarticon from '../../assets/images/admin/sidebar/ShoppingCart.svg';
import sidebar_home from '../../assets/images/admin/sidebar/sidebar_home.svg';
import sidebar_user from '../../assets/images/admin/sidebar/sidebar_user.svg';
import sidebar_products from '../../assets/images/admin/sidebar/sidebar_products.svg';
import sidebar_customer from '../../assets/images/admin/sidebar/sidebar_customers.svg';
import sidebar_order from '../../assets/images/admin/sidebar/sidebar_orders.svg';
import sidebar_sales from '../../assets/images/admin/sidebar/sidebar_sales.svg';
import sidebar_inventory from '../../assets/images/admin/sidebar/sidebar_inventory.svg';
import sidebar_discounts from '../../assets/images/admin/sidebar/sidebar_discounts.svg';
import sidebar_refunds from '../../assets/images/admin/sidebar/sidebar_refund.svg';
import sidebar_reviews from '../../assets/images/admin/sidebar/sidebar_review.svg';
import sidebar_signout from '../../assets/images/admin/sidebar/sidebar_signout.svg';
import sidebar_home1 from '../../assets/images/admin/sidebar/sidebar_home1.svg';
import sidebar_users1 from '../../assets/images/admin/sidebar/sidebar_users1.svg';
import sidebar_products1 from '../../assets/images/admin/sidebar/sidebar_products1.svg';
import sidebar_customer1 from '../../assets/images/admin/sidebar/sidebar_customers1.svg';
import sidebar_order1 from '../../assets/images/admin/sidebar/sidebar_order1.svg';
import sidebar_sales1 from '../../assets/images/admin/sidebar/sidebar_sales1.svg';
import sidebar_inventory1 from '../../assets/images/admin/sidebar/sidebar_inventory1.svg';
import sidebar_discounts1 from '../../assets/images/admin/sidebar/sidebar_discounts1.svg';
import sidebar_refunds1 from '../../assets/images/admin/sidebar/sidebar_refunds1.svg';
import sidebar_reviews1 from '../../assets/images/admin/sidebar/sidebar_reviews1.svg';
import sidebar_signout1 from '../../assets/images/admin/sidebar/sidebar_signout1.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faTrash, faGauge, faGift, faPercent, faTruck, faTable, faTag, faAlignJustify, faHandshake, faTableList, faFilter,
    faRectangleAd, faCartShopping, faCartFlatbed, faCartPlus , faDisplay, faComment, faRankingStar,
    faAngleDown, faAngleUp, faBlog, faChartBar, faTags, faHashtag, faBox, faTicket, faFileInvoice, faUserGroup, faStarHalfStroke, faMoneyBillTransfer, faImage,
    faNewspaper, faCalendar, faStar, faBullhorn, faGear, faShieldHalved
 } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";


const Sidebar = () => {
  const [selectedindex, setselectedindex] = useState(0);

  const location = useLocation();
//   console.log('location >>', location);
    var navdata = [
        {name: 'Dashboard', icon: faChartBar, activeicon:faChartBar, route: 'dashboard'},
        {name: 'Users', icon: faUserGroup, activeicon:faUserGroup, route: 'users'},
        {name: 'Posts', icon: faImage, activeicon:faImage, route: 'posts'},
        {name: 'Moderation', icon: faShieldHalved, activeicon:faShieldHalved, route: 'moderation'},
        {name: 'Articles', icon: faNewspaper, activeicon:faNewspaper, route: 'articles'},
        {name: 'Events', icon: faCalendar, activeicon:faCalendar, route: 'events'},
        {name: 'Feedbacks', icon: faStar, activeicon:faStar, route: 'feedbacks'},
        {name: 'Notifications', icon: faBullhorn, activeicon:faBullhorn, route: 'notifications'},
        {name: 'Settings', icon: faGear, activeicon:faGear, route: 'settings'},


        // {name: 'Categories', icon: faTable, activeicon:faTable, route: 'categories'},
        // {name: 'Sub Categories', icon: faTable, activeicon:faTable, route: 'sub-categories'},
        // {name: 'Tags', icon: faHashtag, activeicon:faHashtag, route: 'tags'},
        // {name: 'Labels', icon: faTags, activeicon:faTags, route: 'labels'},
        // {name: 'Products', icon: faBox, activeicon:faBox, route: 'products'},
        // {name: 'Coupons', icon: faTicket, activeicon:faTicket, route: 'coupons'},
        // {name: 'Orders', icon: faFileInvoice, activeicon:faFileInvoice, route: 'orders'},
        // {name: 'Reviews', icon: faStarHalfStroke, activeicon:faStarHalfStroke, route: 'reviews'},
        // {name: 'Refunds', icon: faMoneyBillTransfer, activeicon:faMoneyBillTransfer, route: 'refunds'},
        // {name: 'Shipping Charges', icon: faTruck, activeicon:faTruck, route: 'shipping-charges'},
        // {name: 'Blogs', icon: faBlog, activeicon:faBlog, route: 'blogs'},
    ]
    return (
        <div className="sidebarmaindiv">
            <img src={mainlogo} className="sidebarlogo" />
            <div className="sidebarnavmaindiv">
                {navdata?.map((item, index) => {
                    var mainclass = "sidebarnavrow";
                    var iconname = "";
                    if(location.pathname == `/admin/${item.route}`) {
                        mainclass = "sidebarnavrow active";
                        // iconname = item?.activeicon;
                    } else {
                        mainclass = "sidebarnavrow";
                        // iconname = item?.icon;
                    }
                    return (
                      <Link
                        to={"/admin/" + item.route}
                        className={mainclass}
                        key={index}
                        onClick={() => {
                          setselectedindex(index);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item?.icon}
                          className="sidebarnavicon"
                        />
                        <p className="shoppingtext">{item.name}</p>
                      </Link>
                    );
                })}
                
            </div>
        </div>
    )
}

export default Sidebar
